export default "__VITE_ASSET__01ebf3c2__"